import api from 'service/api'
import { GUEST_AUTH_TOKEN, GUEST_PORTAL_TOKEN } from 'service/constants'
import * as service from 'service'
import { getWebsiteURL } from 'service/env'
import changeCaseKeys from 'helpers/changeCase/keys'

const dponetAPI = api.create('guestPortal', false)

const login = async (code, accessToken) => {
  return await dponetAPI.post(
    '/login',
    { code },
    { headers: { 'X-Guests-2FA-Token': accessToken } },
  )
}

const setToken = (token) => localStorage.setItem(GUEST_AUTH_TOKEN, token)

const getToken = () => {
  const token = localStorage.getItem(GUEST_AUTH_TOKEN)
  return token === 'null' ? null : token
}

const removeToken = () => localStorage.removeItem(GUEST_AUTH_TOKEN)

const setPortalToken = (token) =>
  localStorage.setItem(GUEST_PORTAL_TOKEN, token)

const getPortalToken = () => {
  const token = localStorage.getItem(GUEST_PORTAL_TOKEN)
  return token === 'null' ? null : token
}

const removePortalToken = () => localStorage.removeItem(GUEST_PORTAL_TOKEN)

const decodeToken = (token) => {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    return changeCaseKeys.camelCase(JSON.parse(atob(base64)))
  } catch {
    return null
  }
}

const isAuthenticated = () => {
  const token = getToken()
  if (!token) return false
  const payload = decodeToken(token)
  if (!payload) return false
  return payload.exp > Date.now() / 1000
}

const logout = (fallbackPortalToken, fallbackOrganizationSlug) => {
  const portalToken = getPortalToken() || fallbackPortalToken
  const organizationSlug = fallbackOrganizationSlug || 'dponet'

  const payload = decodeToken(getToken())
  const modulePath = payload?.guestModule
    ? payload.guestModule.replace(/_/g, '-')
    : 'privacy-by-design'

  removeToken()
  if (portalToken) {
    service.history.push(
      `/${organizationSlug}/guests/${portalToken}/${modulePath}`,
    )
  } else {
    window.open(getWebsiteURL(), '_self')
  }
}

export default {
  decodeToken,
  getPortalToken,
  getToken,
  isAuthenticated,
  login,
  logout,
  removePortalToken,
  removeToken,
  setPortalToken,
  setToken,
}
